module.exports = __webpack_public_path__ + "static/img/Bythian_logo.4f27ee3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/Bythian_logo.png
// module id = MBJJ
// module chunks = 0